// extracted by mini-css-extract-plugin
export default {"productCarousel":"n0-z"};